<template>
  <div>
    <div class="inline-block pr-4 pb-4 w-1/2">
      <p
        class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
      >
        {{ label }}
      </p>
    </div>
    <div class="inline-block pb-4 w-1/2">
      <span v-if="value" class="flex flex-wrap">
        <div v-for="(media, index) in value" :key="index" class="flex-grow">
          <img
            v-if="isImage(media)"
            :src="media.url"
            class="rounded mb-4 mr-2 w-9"
            height="120"
            width="120"
          />
          <p v-else class="mb-4"><a :href="media.url">{{ media.name }}</a></p>
        </div>
      </span>
      <p
        v-else
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
      >
        Not provided
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoeCellUpload",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      type: Array
    }
  },
  methods: {
    isImage(media) {
      return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'].includes(media.type);
    }
  }
};
</script>

<style lang="scss" scoped></style>
